
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.952 9.952C7 12.905 7 17.657 7 27.16v1.68c0 9.503 0 14.255 2.952 17.208C12.905 49 17.657 49 27.16 49h1.68c9.503 0 14.255 0 17.208-2.952C49 43.095 49 38.343 49 28.84v-1.68c0-9.503 0-14.255-2.952-17.208C43.095 7 38.343 7 28.84 7h-1.68C17.657 7 12.905 7 9.952 9.952zm29.07 14.309c0 6.816-5.345 14.68-15.12 14.68-2.998 0-5.797-.855-8.123-2.332a9.95 9.95 0 0 0 1.268.075c2.49 0 4.783-.824 6.601-2.204-2.325-.043-4.287-1.53-4.96-3.585a5.446 5.446 0 0 0 2.402-.086c-2.434-.481-4.264-2.557-4.264-5.06v-.065a5.34 5.34 0 0 0 2.403.642c-1.433-.92-2.37-2.504-2.37-4.29 0-.943.265-1.83.717-2.59 2.623 3.124 6.535 5.179 10.954 5.393-.099-.375-.143-.77-.143-1.177 0-2.847 2.38-5.158 5.312-5.158 1.532 0 2.91.62 3.88 1.626a10.96 10.96 0 0 0 3.372-1.252 5.187 5.187 0 0 1-2.337 2.857 11.04 11.04 0 0 0 3.053-.813 10.716 10.716 0 0 1-2.656 2.675c.011.214.011.439.011.664z","fill":"#4BA0EB"}})])
          )
        }
      }
    